import script from "./ModuloJuridico.vue?vue&type=script&setup=true&lang=js"
export * from "./ModuloJuridico.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__